import React from 'react';
import GridTable from '../../../../common/GridTable';
import DropdownMenu from '../../../../common/MenuDropdown';
import { tableHead } from '../../../../common/tabeHelpers';
import { useSelector } from 'react-redux';
import { handleNameColumns, handleStatusColumn, HandleContactDetailsColumn } from '../../ReusableComponents/TeamTableHelpers';
import { GetTeamsListLogic } from '../../TeamController';
import { useNavigate } from 'react-router-dom';
import OperationalAreasColumn from '../CommonComponentsForTable/OperationalAreasColumn';
import AssetsTableColumn from '../CommonComponentsForTable/AssetsTableColumn';
import UseCaseTableColumn from '../CommonComponentsForTable/UseCaseTableColumn';
import ToolsTableColumn from '../CommonComponentsForTable/ToolsTableColumn';
import InventoryColumn from '../CommonComponentsForTable/InventoryColumn';
import APIFilterPopup from '../../../../common/APIFilters/FilterPopup';
import Loader from '../../../../common/Loader';
import { IncomeColumn } from '../CommonComponentsForTable/IncomeColumn';
import { isToShowUserIncomeDetails } from '../../../../utils/access';
import { validateNumberValue } from '../../../../utils/common';
import { roles } from './SPContainer';

export default function SPTable(props) {
    const {
        partnersFilteredList,
        filterList,
        setFilterList,
        customerId,
        apiQuery,
        openTab,
        handleUserClick,
        isUserOpen,
        isSideDrawerOpen,
        filterSchema,
        filterQueryObject,
        filtersActiveStatus,
        updateQueryFilters,
        partnerFilterData,
        rowsPerPage,
        page,
        showClearFilterButton,
        searchKey
    } = props;

    const { isPArtnersListLoading, isPartnerListDetailsLoading, isPartnerFIlterListLoading } = useSelector((state) => state.loading);

    const { loggedUser } = useSelector((state) => state.auth);
    const { usersCount, filteredUsersCount } = useSelector((state) => state.partners);
    const totalCount = showClearFilterButton || searchKey?.length > 0 ? filteredUsersCount[openTab] : usersCount?.[openTab];
    const role = loggedUser.role.id;
    const type = loggedUser.type;
    const navigate = useNavigate();
    const { selectedTeamUserDetails } = useSelector((state) => state.customer);

    const filterComponent = ({ headName, keysToFilter, typeOfFilter, placement }) => (
        <div className='flex items-center'>
            <p className='text-font13'>{headName}</p>
            <APIFilterPopup
                filterList={filterList}
                setFilterList={setFilterList}
                height={15}
                keysToFilter={keysToFilter}
                submit={({ payload, page, filterList }) => updateQueryFilters({ filterSchema, payload, page, filterList })}
                typeOfFilter={typeOfFilter}
                placement={placement}
                isLoading={isPartnerFIlterListLoading}
                filtersData={partnerFilterData}
                filterSchema={filterSchema}
                filterQueryObject={filterQueryObject}
                filtersActiveStatus={filtersActiveStatus}
            />
        </div>
    );

    const getTableSchema = () => {
        let columns = [
            {
                head: {
                    thClassName: 'min-w-60 w-60 pl-p-15',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.full_name],
                        });
                    },
                    headName: 'Name',
                },
                body: handleNameColumns({ className: 'min-w-60 w-60 pl-p-15 break-words', handleClick: handleUserClick, role, type }),
            },
            {
                head: {
                    thClassName: 'min-w-72 w-72',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.mobiles],
                        });
                    },
                    headName: 'Contact Details',
                },
                body: {
                    render: (item) => {
                        return <HandleContactDetailsColumn item={item} className={'min-w-72 w-72 break-words'} />
                    }
                },

            },
            {
                head: {
                    thClassName: 'min-w-96 w-96',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.operational_areas, filterSchema.districts],
                        });
                    },
                    headName: 'Operational Areas',
                },
                body: {
                    bodyClassName: 'min-w-96 w-96',
                    render: (user) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return (
                            <OperationalAreasColumn
                                name={`${user.first_name} ${user.last_name}`}
                                spId={user.sp_id}
                                office_location={user?.office_location}
                                incentive_areas={user.incentive_areas}
                                userId={user.id}
                                roles={roles}
                            />
                        );
                    },
                },
            },
            {
                head: {
                    thClassName: 'min-w-72 w-72',
                    render: (headName) => headName,
                    headName: 'Income',
                },
                body: {
                    bodyClassName: 'min-w-72 w-72',
                    render: (user) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return <IncomeColumn income_details={user.income_details} />
                    }
                }
            },
            {
                head: tableHead('Assets', 'min-w-36 w-36', undefined, { hide: isSideDrawerOpen }),
                body: {
                    bodyClassName: 'min-w-36 w-36',
                    render: (item) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return <AssetsTableColumn name={`${item.first_name + ' ' + item.last_name}`} data={item.worked_on_asset_types} />;
                    },
                },
            },
            {

                head: {
                    thClassName: 'min-w-36 w-36',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.usecases],
                        });
                    },
                    headName: 'Usecases',
                },
                body: {
                    bodyClassName: 'min-w-36 w-36',
                    render: (item) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return <UseCaseTableColumn name={`${item.first_name + ' ' + item.last_name}`} data={item.worked_on_use_cases} />;
                    },
                },
            },
            {
                head: {
                    thClassName: 'min-w-36 w-36',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.status],
                        });
                    },
                    headName: 'Status',
                    hide: isSideDrawerOpen,
                    columnRowCss: 'break-words',
                },
                body: handleStatusColumn({ className: 'min-w-36 w-36' }),
            },
            {
                head: {
                    render: (headName) => headName,
                    headName: 'Inventory',
                    hide: isSideDrawerOpen,
                },
                body: {
                    render: (item) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return item?.inventory ? (
                            <InventoryColumn available={item.inventory.available} delivered={item.inventory.delivered} inTransit={item.inventory.transit} />
                        ) : (
                            <></>
                        );
                    },
                },
            },
            {
                head: {
                    thClassName: 'min-w-36 w-36',
                    render: (headName) => {
                        return filterComponent({
                            headName,
                            keysToFilter: [filterSchema.tools],
                        });
                    },
                    headName: 'Tools',
                },
                body: {
                    render: (item) => {
                        if (isPartnerListDetailsLoading) return <ColumnLoader />
                        return <ToolsTableColumn item={item} data={item.service_partner_tools} customerId={customerId} apiQuery={apiQuery} />;
                    },
                },
            },
            {
                head: {
                    headName: 'Actions',
                    render: (headName) => headName,
                    width: 0.5,
                },
                body: {
                    render: (item) => {
                        return (
                            <div className='flex justify-center'>
                                <SpActionColumn item={item} openTab={openTab} customerId={customerId} apiQuery={apiQuery} />
                            </div>
                        );
                    },
                },
            },
        ]
        columns = columns.filter((column) => {
            if (column.head.headName === 'Income') {
                return isToShowUserIncomeDetails(loggedUser.frontend_controller)
            }
            return true;
        })
        return { table: columns }
    }

    const tableSchema = getTableSchema();

    return (
        <GridTable
            schema={tableSchema}
            rowData={partnersFilteredList}
            isLoading={isPArtnersListLoading}
            tableError={'No Vendors Found'}
            trClassNames='overflow-hidden pt-1'
            tablePagination={true}
            count={validateNumberValue(totalCount)}
            tablePaginationHandler={(limit, page) => updateQueryFilters({ limit, page, filterSchema, filterList })}
            checkRowShouldHighlight={(item) => isUserOpen && item.id === selectedTeamUserDetails?.id}
            rowsPerPage={rowsPerPage}
            page={page}
        />
    );
}


export const ColumnLoader = () => {
    return <div className='relative w-4/12'>
        <Loader color={'#F48A21'} size='15' speed='1' thickness='2' />
    </div>
}

const SpActionColumn = (props) => {
    const { item, openTab, customerId, apiQuery } = props;
    const spActionList = (item) => GetTeamsListLogic('scmPartnerActions', { user: item, openTab });
    const navigate = useNavigate();
    const { loggedUser } = useSelector((state) => state.auth);

    return (
        <DropdownMenu
            menuData={spActionList(item)}
            item={item}
            componentOrIcon={'more_vert'}
            payload={{ customerId, ...apiQuery, navigate, loggedUserRole: loggedUser.role.id, loggedUserEmail: loggedUser.email }}
        />
    );
};